import React from "react"

import UI5_PillBox from "../../../../../gd-components/molecules/pillbox/ui5-pillbox"
import {FieldViewSize} from "../../../../const"
import {FieldEditableValueNotEmptyProps} from "../../../../proto/components/editable/value-not-empty"

export default function FieldDropdown_ValueNotEmpty(props:FieldEditableValueNotEmptyProps) {

    const {option} = props

    const size          = _.get(props, 'size', FieldViewSize.DEFAULT)
    const showIcon      = _.get(props, 'configOptions.showIcon', true)
    const optionColor   = _.get(option, 'color', null); //!_.isNil(option.color) ? option.color : null;

    if (optionColor) {
        return (
            <React.Fragment>
                <UI5_PillBox onClick    = {props.onClick}
                             label      = {option.label}
                             className  = 'selector m-l-10'
                             color      = {optionColor}
                             size       = {26}
                />
                {props.children}
            </React.Fragment>
        )
    }

    if (!optionColor) {
        const valueClasses = Classes("ui5-field-dropdown-inline-editable", props.className, {
            'ui5-txt-default'               : size === FieldViewSize.DEFAULT,
            'ui5-txt-less-important-small'  : size === FieldViewSize.SMALL,

            // the smaller box - .ui5-field-dropdown-inline-editable sets min-height and
            // padding, which no helper class on the element can win against
            'size-small'                    : size === FieldViewSize.SMALL
        })

        let icon
        if (showIcon) {
            icon = _.get(props.field.components, 'ValueIcon', false)
            if (!icon && option.icon) {
                icon = <div className={Classes('ui5-ico-14 m-r-5', option.icon)}></div>
            }
        }

        return (
            <>
                <div className={valueClasses} onClick={props.onClick}>
                    {icon}
                    {_.get(props.field.components, 'ValuePrefix', false)}
                    {/* m-b-2 lifts the text 1px in the centred row - its line box carries the
                        descender room below the baseline, so centred as is the lowercase sits
                        low against the icon */}
                    <div className="txt-truncate m-b-2">{option.label}</div>
                </div>
                {props.children}
            </>
        )
    }
}
